//Common
import { TIPO_SOLICITACAO } from "@/common/constantes";

//Componentes
import TooltipItem from "../componentes/TooltipItem";

//ÍCONES
import { BiDetail, BiLogOut } from "react-icons/bi";
import { CiEdit } from "react-icons/ci";
import { CgMathPlus, CgMathMinus, CgDanger } from "react-icons/cg";
import { TfiHelpAlt, TfiExport, TfiImport } from "react-icons/tfi";
import {
  PiClockFill,
  PiIdentificationCardThin,
  PiWarningFill,
  PiWarningLight,
} from "react-icons/pi";
import { RxAvatar } from "react-icons/rx";
import { HiCheck } from "react-icons/hi";
import { LuDollarSign, LuPrinter, LuUsers } from "react-icons/lu";
//import { GoEye, GoEyeClosed } from "react-icons/go";
import {
  BsCalendarDate,
  BsCart2,
  BsCheck2Circle,
  BsCurrencyDollar,
  BsEye,
  BsPinAngle,
  BsPinAngleFill,
  BsThreeDots,
} from "react-icons/bs";

import { TiDocument } from "react-icons/ti";

import { VscError } from "react-icons/vsc";

import {
  IoCalendarOutline,
  IoClose,
  IoDocumentTextSharp,
  IoReloadOutline,
} from "react-icons/io5";

import {
  GrAddCircle,
  GrAppsRounded,
  GrCircleInformation,
  GrDocumentConfig,
  GrDocumentCsv,
  GrDocumentPdf,
  GrDownload,
  GrMultiple,
  GrSystem,
  GrUserManager,
} from "react-icons/gr";

import {
  FaCheckCircle,
  FaCheckDouble,
  FaCircle,
  FaEye,
  FaEyeSlash,
  FaHourglassHalf,
  FaLock,
  FaRegFileAlt,
  FaRegHandshake,
  FaTimesCircle,
  FaUser,
  FaUserCheck,
  FaUsers,
} from "react-icons/fa";
import { FaRegCircleStop, FaRegCircleUser } from "react-icons/fa6";

import {
  IoIosArrowBack,
  IoIosArrowDown,
  IoIosArrowForward,
  IoMdAdd,
  IoMdArrowDown,
  IoMdArrowUp,
  IoMdAttach,
} from "react-icons/io";
import {
  TbCancel,
  TbCircleDashedLetterC,
  TbFilter,
  TbFilterCheck,
  TbFilterPlus,
  TbFilterX,
} from "react-icons/tb";

import {
  MdAutoAwesome,
  MdOutlineDelete,
  MdOutlineDocumentScanner,
  MdOutlineWarningAmber,
  MdOutlineNavigateNext,
  MdOutlineNavigateBefore,
  MdOutlineClose,
  MdOutlineCheck,
  MdOutlineSearch,
  MdClose,
  MdDoneAll,
  MdMonitor,
  MdMoreHoriz,
  MdReplay,
  MdNotifications,
  MdZoomIn,
  MdOutlineBarChart,
  MdMenu,
  MdMenuOpen,
  MdRotateRight,
} from "react-icons/md";

import { FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";

//ICONES - MENUS
export const ICONES_MENU = {
  HOME: <GrAppsRounded />,
  AVATAR: <RxAvatar />,
  ACOES: <MdMoreHoriz />,

  GESTORA: <GrUserManager />,
  MONITOR: <MdMonitor />,
  CADASTRO: <BiDetail />,
  CONSULTA: <MdOutlineSearch />,
  ACESSO: <FaUserCheck />,
  CONFIGURACAO: <GrDocumentConfig />,
  SYSTEM: <GrSystem />,

  //Menu lateral: abrir e recolher
  MENU_LATERAL_ABRIR: <MdMenu />,
  MENU_LATERAL_RECOLHER: <MdMenuOpen />,
};

//ICONES - ITENS DE MENU
export const ICONES_MENU_ITEM = {
  ALTERAR_SENHA: <FaLock />,
  LOGOUT: <BiLogOut />,
  NOTIFICACAO: <MdNotifications />,
};

//ICONES - BOTOES
export const ICONES_BOTAO = {
  NOVO: <GrAddCircle />, //<TiDocumentAdd />,
  EDITAR: <CiEdit />,
  SALVAR: <MdOutlineCheck />,
  EXCLUIR: <MdOutlineDelete />,
  CANCELAR: <TbCancel />,
  CONFIRMAR: <MdOutlineCheck />,
  CONSULTAR: <MdOutlineSearch />,
  FECHAR: <MdOutlineClose />,
  DETALHAR: <BiDetail />,
  VISUALIZAR: <BsEye />,
  AUTORIZAR: <FaUserCheck />,
  DOWNLOAD: <GrDownload />,
  PDF: <GrDocumentPdf color="#E60000" size="22px" />,
  CSV: <GrDocumentCsv color="green" size="22px" />,
  ESTATISTICA: <MdOutlineBarChart color="#0d6efd" size="22px" />,
  IMPRIMIR: <LuPrinter />,
  LUPA: <MdZoomIn />,
  GIRAR: <MdRotateRight />,
  IMPORTAR: <TfiImport />,
  LEITURA_IA: <MdAutoAwesome />, //leitura de documento por IA
  EXPORTAR: <TfiExport />,
  LAYOUT_ARQUIVO: <FaRegFileAlt />,
  LOG: <BiDetail />,
  RELOAD: <IoReloadOutline />,
  FIXAR: <BsPinAngle />, //fixar o arquivo ao lado da tela
  SOLTAR: <BsPinAngleFill />, //soltar o arquivo fixado
};

//ICONES - FILTRO
export const ICONES_FILTRO = {
  FILTRO: <TbFilter />,
  FILTRO_ADD: <TbFilterPlus />,
  FILTRO_X: <IoClose />,
  FILTRO_DEL: <TbFilterX />,
  FILTRO_CHECK: <TbFilterCheck />,
};

//ICONES - PAGINACAO
export const ICONES_PAGINACAO = {
  NEXT: <MdOutlineNavigateNext />,
  PREV: <MdOutlineNavigateBefore />,
  SEM_REGISTROS: <MdOutlineWarningAmber />,
};

//ICONES - SETAS
export const ICONES_SETA = {
  ABRIR_DETALHE: <IoIosArrowDown />,
  FECHAR_DETALHE: <IoIosArrowForward />,

  //Ano anterior / próximo do seletor de mês/ano
  ANTERIOR: <IoIosArrowBack />,
  PROXIMO: <IoIosArrowForward />,

  ENTRADA: <FiArrowUpCircle />,
  SAIDA: <FiArrowDownCircle />,

  ORDENACADO_HEAD_UP: <IoMdArrowUp />,
  ORDENACADO_HEAD_DOWN: <IoMdArrowDown />,
};

//ICONES - TIPOS DE MENSAGEM
export const ICONES_MENSAGEM = {
  AJUDA: <TfiHelpAlt />,
  INFO: <GrCircleInformation />,
  AVISO: <PiWarningFill />, //<PiWarningThin />
  ATENCAO: <CgDanger />, //<CgDanger />, //<GrCircleAlert />,
  ERRO: <VscError />,
  OK: <HiCheck />,
  PRAZO: <PiClockFill />,
};

//ICONES - DASHBOARD
export const ICONES_CARD_DASHBOARD = {
  AVISO: <PiWarningLight />,
  ATENCAO: <CgDanger />,
  SUCESSO: <BsCheck2Circle />,
  CHECK: <HiCheck />,
};

//ICONES - ACESSO
export const ICONES_ACESSO = {
  SENHA: <FaLock />,
  USUARIO: <FaUser />,
  USUARIOS: <FaUsers />,

  AUTORIZACAO_REQUERIDA: <FaRegCircleUser />,
  OLHO_ABERTO: <FaEye />, //<GoEye />,
  OLHO_FECHADO: <FaEyeSlash />, //<GoEyeClosed />,
};

//ICONES - OPERAÇÃO
export const ICONES_OPERACAO = {
  ADD: <IoMdAdd />,
  X: <MdClose />,
  ALL: <MdDoneAll />,
  MAIS: <CgMathPlus />,
  MENOS: <CgMathMinus />,
};

//ICONES - SITUAÇÃO
export const ICONES_SITUACAO = {
  ATIVO: <FaCheckCircle />,
  PROCESSANDO: <FaHourglassHalf />,
  ERRO: <FaTimesCircle />,
};

export const ICONES = {
  CIRCULO: <FaCircle />,
  CIRCULO_UP: <FaCircle color="green" />,
  CIRCULO_DOWN: <FaCircle color="red" />,

  CHECK: <HiCheck />,
  CHECK_VERDE: <HiCheck color="green" />,
  CHECK_DUPLO: <FaCheckDouble />,

  CALENDARIO: <IoCalendarOutline />, //<IoCalendarNumberOutline />, //<FcCalendar size="22px" />,

  //Indica campo preenchido pela leitura de documento, que precisa ser conferido
  // LEITURA_DOCUMENTO: <MdOutlineDocumentScanner color="#0d6efd" size="11px" />,
  LEITURA_DOCUMENTO: <MdAutoAwesome color="#0d6efd" size="13px" />,

  PARAR: <FaRegCircleStop />,

  DOTS3_H: <BsThreeDots />,
};

export const ICONES_SIIG = {
  IDENTIFICACAO: <PiIdentificationCardThin />,
  FORMALIZACAO: <BiDetail />,
  RESPONSAVEIS: <LuUsers />,
  CONTRATO: <FaRegHandshake />,
  PAGAMENTOS: <BsCurrencyDollar />,
  ANEXOS: <IoMdAttach />,

  PARCEIRO: <FaRegHandshake />,
  VIGENCIA: <BsCalendarDate />,
  FINANCEIRO: <BsCurrencyDollar />,
  REAJUSTE: <LuDollarSign />,

  PAGAMENTO: <BsCart2 />,
  RECEITA: <BsCurrencyDollar />,
  CONTROLE: <TbCircleDashedLetterC />,
  RATEIO: <BiDetail />,
  DOCUMENTO: <IoDocumentTextSharp />,

  PAG_UNICO: <TiDocument />,
  PAG_PARCELADO: <GrMultiple />,
  PAG_RECORRENTE: <MdReplay />,

  INICIO_IA: <MdAutoAwesome color="#0d6efd" size="22px" />, //versão do início do uso da IA (consulta do changelog)
};

/*
 * Função chamada ao lado do nome de cada coluna para retornar o ícone de ordenação
 * caso o resultado esteja ordenado pela coluna em questão.
 * Retorna a seta para cima (asc) ou para baixo (desc) conforme a direção da ordenação da coluna
 */
export function fn_getIconeOrdenacao(campoOrder, direcaoOrder, nomeColuna) {
  if (
    (!Array.isArray(nomeColuna) && nomeColuna == campoOrder) ||
    (Array.isArray(nomeColuna) && nomeColuna.includes(campoOrder))
  ) {
    return (
      <span>
        {direcaoOrder.toUpperCase() === "ASC" ? (
          <TooltipItem text="Crescente">
            {ICONES_SETA.ORDENACADO_HEAD_UP}
          </TooltipItem>
        ) : (
          <TooltipItem text="Decrescente">
            {ICONES_SETA.ORDENACADO_HEAD_DOWN}
          </TooltipItem>
        )}
      </span>
    );
  } else {
    return null;
  }
}

//Retorna o ícone que representa o tipo da solcicitacao
export function fn_getIconeTipoSolicitacao(tipo) {
  switch (tipo) {
    case TIPO_SOLICITACAO.PAGAMENTO:
      return ICONES_SIIG.PAGAMENTO;

    case TIPO_SOLICITACAO.RECEITA:
      return ICONES_SIIG.RECEITA;
  }
}
